import React from 'react';
const AnalyticsContext = /*#__PURE__*/React.createContext({
  fireAnalyticsEvent: _event => null
});
export default AnalyticsContext;